import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14bfa349"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frame" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  id: "weixinLayout",
  class: "weixinDiv"
}

import {
  onMounted,
  ref,
  // type CSSProperties,
  // computed,
  withDefaults,
} from 'vue';
import Vrouter from '@/router';
import OpenWpsBridge from '../bridge/OpenWpsBridge';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import WxService from '../service/WxService';
import KLog from '../../utils/KLog';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import { ShareContent } from '../bridge/ShareObject';
import i18n from '@/i18n';
import { openStoreByPlatform } from '../../utils/StoreConfig';
import { getAppIcon } from '../../utils/RegionAssets';

export interface OpenButtonStyle {
  position?: string;
  left?: string;
  background: string;
  'border-radius': string;
  'border-width': string;
  width: string;
  height: string;
  'font-size': string;
  color: string;
  'text-decoration-line': string;
  'text-align'?: string;
}

export interface RealButtonStyle {
  'font-size': string;
  color: string;
  'text-decoration-line': string;
}

interface OpenButtonProps {
  openBtnStyleObj: OpenButtonStyle;
  openBtnText: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenAppButton',
  props: {
    openBtnStyleObj: { default: () => ({
    background: '#00FF00',
    'border-radius': '18px',
    'border-width': '0px',
    width: '300px',
    height: '54px',
    'font-size': '18px',
    color: '#fff',
    'text-decoration-line': 'none',
  }) },
    openBtnText: { default: i18n.global.t('common.openWpsExperience') }
  },
  emits: ['commonOpen', 'onWeixinLaunch', 'onWeixinLaunchFail'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

// const openButtonStyle = computed(() => {
//   return {
//     ...props.openBtnStyleObj,
//   } as CSSProperties;
// });

const weixinShow = ref(false);
const weixinExtraData = ref('');

const buttonHtml = ref();

// const buttonRef = ref();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onReady(e: any) {
  KLog.log('onReady', e);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// function proxyOpen(event: any) {
//   event.stopPropagation();
//   if (weixinShow.value) {
//     buttonRef.value.$.vnode.el?.click();
//   } else {
//     openAction();
//   }
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function commonOpen() {
  // event.stopPropagation();
  openAction();
}

function openAction() {
  emit('commonOpen');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
function onLaunch(e: any) {
  autoJumpDownload();
  emit('onWeixinLaunch');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
function onError(e: any) {
  if (e.detail.errMsg === 'launch:fail') {
    openStoreByPlatform(AbilityParamsUtil.getDownloadUrl());
  }
  emit('onWeixinLaunchFail');
}

function autoJumpDownload() {
  setTimeout(() => {
    Vrouter.push({
      path: '/mobile_avocado_ck/download',
      query: {
        chan: AbilityParamsUtil.getDownloadChan(),
        autoJump: AbilityParamsUtil.isAutoJumpDownload() ? '1' : '0',
        ability: AbilityParamsUtil.getAbilityName(),
        _business_id: AbilityParamsUtil.getAbilityBusinessId(),
      },
    });
  }, 1000);
}

function initButtonStyle() {
  let width = props.openBtnStyleObj.width;
  let height = props.openBtnStyleObj.height;
  if (width.indexOf('%') > -1) {
    width = '300px';
  }
  if (height.indexOf('%') > -1) {
    height = '54px';
  }
  let html = [
    ' <script type="text/wxtag-template">',
    '   <style>.weixinLayout {',
    '     opacity: 0;',
    '     width: ',
    width,
    ';',
    '     height: ',
    height,
    ';',
    '     }',
    '   </style>',
    '   <div class="weixinLayout"></div>',
    '</scrip' + 't>',
  ].join('');
  buttonHtml.value = html;
}

function showWeixinOpen() {
  weixinShow.value = true;
}

function showCommonOpen() {
  weixinShow.value = false;
}

function initOpenButton() {
  initButtonStyle();
  let shareContent: ShareContent = AbilityParamsUtil.getShareObj().share_content;
  if (shareContent.title === undefined || shareContent.title === '') {
    shareContent.title = i18n.global.t('common.wpsOffice');
  }
  if (shareContent.desc === undefined || shareContent.desc === '') {
    shareContent.desc = i18n.global.t('template.desc');
  }
  if (shareContent.icon === undefined || shareContent.icon === '') {
    shareContent.icon = getAppIcon();
  }
  if (DeviceEnvUtil.isWeixin()) {
    if (AbilityParamsUtil.isUseWxOpenTag()) {
      let currentUrl = window.location.href;
      weixinExtraData.value = OpenWpsBridge.translateNewDeeplink();
      WxService.loadWxSDK()
        .then(() => {
          WxService.requestSign(currentUrl)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
              WxService.initConfig(
                shareContent,
                {
                  ...res.data,
                },
                () => {
                  KLog.log('initConfig success');
                  showWeixinOpen();
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (error: any) => {
                  KLog.log('initConfig fail: ', error);
                  showCommonOpen();
                },
              );
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((error: any) => {
              KLog.log('requestSign error: ', error);
              showCommonOpen();
            });
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          KLog.log('loadWxSDK error: ', error);
          showCommonOpen();
        });
    } else {
      KLog.log('Anthorization fail: ');
      showCommonOpen();
    }
  } else {
    showCommonOpen();
  }
}

onMounted(() => {
  initOpenButton();
});

return (_ctx: any,_cache: any) => {
  const _component_wx_open_launch_app = _resolveComponent("wx-open-launch-app")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "actionButton",
      onClick: _withModifiers(commonOpen, ["self"])
    }, _toDisplayString(_ctx.openBtnText), 9, _hoisted_2),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_wx_open_launch_app, {
        ref: "wxOpen",
        innerHTML: buttonHtml.value,
        appid: "wx3ebc9e606b4f9242",
        extinfo: weixinExtraData.value,
        onReady: onReady,
        onLaunch: onLaunch,
        onError: onError
      }, null, 8, ["innerHTML", "extinfo"])
    ], 512), [
      [_vShow, weixinShow.value]
    ])
  ]))
}
}

})